const mutationTypes = {
  SET_UPLOAD_QUEUE: 'SET_UPLOAD_QUEUE',

  SET_LOADING: 'SET_LOADING',
  REMOVE_FILE_FROM_QUEUE: 'REMOVE_FILE_FROM_QUEUE',
}

const actionTypes = {
  UPLOAD_QUEUE: 'UPLOAD_QUEUE'
}

export {mutationTypes, actionTypes}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolUploadTypes.js